module.exports = __webpack_public_path__ + "static/media/arrow-down.cfee83b2.svg";